import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './MainTab';
import Main from './MainTab';
import { StoreState } from 'src/store/reducers';
import { getFiles } from 'src/store/actions/provider-actions';
import { getExigentBonusStatus, resetExigentBonusStatus } from 'src/store/actions/bonus-actions';
import { QueryParams } from 'src/types/grid';
import { getServiceTypes } from 'src/store/actions/service-type-actions';
import { selectNameSerTypes } from 'src/store/selectors/service-types-selectors';
import { getServiceLocations } from 'src/store/actions/service-location-actions';
import { selectNameSerLocations } from 'src/store/selectors/service-location-selectors';
import { getCases, getCasesSmall } from '../../../../../../../../store/actions/case-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        serviceTypes: selectNameSerTypes(state),
        serviceLocations: selectNameSerLocations(state),
        files: state.providers.currentFiles,
        cases: state.cases.data.list,
        inProgress: state.cases.inProgress,
        exigentBonusStatus: state.bonuses.exigentBonusStatus,
        exigentBonusStatusInProgress: state.bonuses.exigentBonusStatusInProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
        getServiceLocations: (params: QueryParams) => dispatch(getServiceLocations(params)),
        getCases: (params: QueryParams) => dispatch(getCasesSmall(params)),
        getFiles: (id: string | number) => dispatch(getFiles(id)),
        getExigentBonusStatus: (id: string | number) => dispatch(getExigentBonusStatus(id)),
        resetExigentBonusStatus: () => dispatch(resetExigentBonusStatus()),
    };
}

const MainTab = connect<StateProps, DispatchProps, OwnProps, StoreState>(mapStateToProps, mapDispatchToProps)(Main);

export default MainTab;
